import { Box } from "@mui/material";
import { JSX } from "react";
//import { Image } from 'mui-image'

export interface ImageComponentProps {
  imageSrc: string;
  imageProps?: {
    width?: string,
    height?: string,
    maxWidth?: string,
    maxHeight?: string,
    borderRadius?: string,
    background?: string,
    float?: string,
    padding?: string,
    paddingTop?: string,
    margin?: string,
    marginTop?: string,
  };
  variant?: "whitebackground";
}

export const ImageComponent = ({ imageSrc, imageProps, variant }: ImageComponentProps): JSX.Element => {

  const sxProps = {};
  
  if (variant) {
    switch(variant) {
      case "whitebackground": {
        sxProps["borderRadius"] = "25px";
        sxProps["background"] = "white";
        sxProps["margin"] = "5px";
        sxProps["padding"] = "2px";
      }
    }
  }

  if (imageProps?.width) { sxProps["width"] = imageProps.width }; 
  if (imageProps?.height) { sxProps["height"] = imageProps.height }; 
  if (imageProps?.maxWidth) { sxProps["maxWidth"] = imageProps.maxWidth }; 
  if (imageProps?.maxHeight) { sxProps["maxHeight"] = imageProps.maxHeight }; 
  if (imageProps?.borderRadius) { sxProps["borderRadius"] = imageProps.borderRadius }; 
  if (imageProps?.background) { sxProps["background"] = imageProps.background };
  if (imageProps?.float) { sxProps["float"] = imageProps.float };
  if (imageProps?.padding) { sxProps["padding"] = imageProps.padding };
  if (imageProps?.paddingTop) { sxProps["paddingTop"] = imageProps.paddingTop };
  if (imageProps?.margin) { sxProps["margin"] = imageProps.margin };
  if (imageProps?.marginTop) { sxProps["marginTop"] = imageProps.marginTop };
   

  return (
    <Box
      component="img"
      sx={sxProps}
      src={imageSrc}
    />  
  );
}  
